import type { FC, SVGProps } from 'react';

export const MoonIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinejoin="round"
        d="M20.25 14.4A8.5 8.5 0 0 1 9.6 3.75a8.5 8.5 0 1 0 10.65 10.65Z"
      />
    </svg>
  );
};
